module.exports = __webpack_public_path__ + "static/media/landingPage_Patient.2031e9e0.md";